import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../components/Buttons';
import DynamicCartIconContainer from '../DynamicCartIcon/DynamicCartIconContainer';

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 48px;
  @media (min-width: 1101px) {
    display: none;
  }
`;

const FlexButton = styled(PrimaryButton)`
  position: absolute;
  background-color: ${(props) => props.theme.reviewOrderButtonBackgroundColor};
  height: 48px;

  &:hover {
    background-color: ${(props) =>
      props.theme.reviewOrderButtonHoverBackgroundColor};
    transition: all 0.25s ease;
  }

  @media (max-width: 1101px) {
    width: 100%;
  }
`;

const CartIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
`;

const Price = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
`;

const ReviewOrderButton = ({
  handleClick,
  totalCartPriceBeforeTax,
  isFoodRequired,
}) => {
  return (
    <Wrapper>
      <FlexButton onClick={handleClick}>
        <CartIconWrapper>
          <DynamicCartIconContainer />
        </CartIconWrapper>
        {isFoodRequired ? 'Food is Required' : 'Review Order'}
        <Price>{totalCartPriceBeforeTax}</Price>
      </FlexButton>
    </Wrapper>
  );
};

export default ReviewOrderButton;
